import { gql } from "../__generated__/gql";

gql(`
    fragment MissionInvoiceFields on MissionInvoice {
        id
        totalAmount
        missionInfo {
            ...MissionInfoFields
        }
    }
`);

gql(`
    fragment InvoiceFields on Invoice {
        id
        fromDate
        toDate
        totalAmount
        invoiceNumber
        invoiceType
        paidAt
        sentAt
        invoiceAsset {
            ...AssetFields
        }
        missionInvoices {
            ...MissionInvoiceFields
        }
        missionInfo {
            id
            earningType
            clientInfo {
                ...ClientInfoFields
            }
            workerInfo {
                ...WorkerInfoFields
            }
            activityType {
                title
                ofsSalariumId
                ofsSalariumGroupId
                id
            }
        }
    }
`);

export const FIND_MY_INVOICES = gql(`
    query FindMyInvoices {
        findMyInvoices {
            count
            elements {
                ...InvoiceFields
            }
        }
    }
`);

export const FIND_WORKER_INVOICES = gql(`
    query FindWorkerInvoices($workerProfileId: ID!) {
        findWorkerInvoices(workerProfileId: $workerProfileId, offset:0, limit:100) {
            count
            elements {
                ...InvoiceFields
            }
        }
    }
`);

export const GET_INVOICE = gql(`
    query GetInvoice($invoiceId: ID!) {
        getInvoice(invoiceId: $invoiceId) {
            ...InvoiceFields
        }
    }
`);
